module.exports = __webpack_public_path__ + "img/illegal_baker_words.1560c93.svg";